module.exports = __webpack_public_path__ + "media/images/flags/1x1/idn-2c0292e48387192d4710e1aebb2ec3b7.svg";